export default __webpack_public_path__ + "static/media/Freebooter's Gloves of Grinning Skulls.bf660e70.jpg";